module.exports = __webpack_public_path__ + "static/media/honeycombPeople2.b6621573.png";